import React from 'react';

import { IEventsHost } from '@r-client/data/graphql-types';
import { Avatar, Box, Text } from '@r-client/shared/ui/core';
export interface IHostProps {
  host: IEventsHost;
  className?: string;
}

export const Host: React.FC<React.PropsWithChildren<IHostProps>> = ({
  host,
  className,
}) => {
  const userFullName = `${host.firstName} ${host.lastName}`;
  return (
    <Box m={Box.top(1)} p={Box.top(1)} className={className}>
      <Avatar
        url={host.avatarUrl || undefined}
        size="medium"
        mobileSize="small"
        alt={userFullName}
      />

      <Box m="0 0 0 1brm">
        <Text as="p" type="h4">
          {userFullName}
        </Text>

        {!!(host.position || host.bio) && (
          <Text as="p" type="bodyBig" color="gray70">
            {host.position || host.bio}
          </Text>
        )}
      </Box>
    </Box>
  );
};
